export const isSDKLite = () => new RegExp('w*( VCO_SDK)w*').test(window.navigator.userAgent);
